<template>
    <div>
        <div class="row">
            <div class="col-lg-4">
                <b-card no-body class="p-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <label class="form-label">Çıkış Yapılan Kasa</label>
                            <v-validator :errors="errors" parameter="VaultCode" :watch="kasa">
                                <v-select-list   v-model="kasa" v-on:input="getKasaDovizDeger" :options="kasaList" label="KSMAS_NAME" placeholder="Çıkış Yapılan Kasa" :loading="kasaLoading"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Hedef Kasa</label>
                            <v-validator :errors="errors" parameter="DestinationKasaKod" :watch="kasa">
                                <v-select-list   v-model="dkasa" :options="kasaListAll" label="KSMAS_NAME" placeholder="Hedef Kasa" :loading="kasaAllLoading"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Proje Kodu</label>
                            <v-validator :errors="errors" parameter="ProjectCode" :watch="projectCode">
                                <v-select-list v-model="projectCode" :options="projectCodes" label="label" placeholder="Proje Kodu"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1" v-if="model.CurrencyType != null && model.CurrencyType != 0">
                            <label class="form-label" >Döviz Tutar</label>
                            <v-validator :errors="errors" parameter="CurrencyAmount" :watch="model.CurrencyAmount">
                                <v-currency-input  v-on:input="calculateValue" input-class="text-right" :value="model.CurrencyAmount" v-on:update-value="currencyAmount => model.CurrencyAmount = currencyAmount"></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1" v-if="model.CurrencyType == 0 || model.CurrencyType == null">
                            <label class="form-label" >Tutar</label>
                            <v-validator :errors="errors" parameter="Amount" :watch="model.Amount">
                                <v-currency-input  input-class="text-right" :value="model.Amount" v-on:update-value="amount => model.Amount = amount"></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-12">
                            <div class="mb-1" v-if="pleaseWait">
                                <span class="text-success">Döviz bilgileri getiriliyor. Lütfen Bekleyiniz... </span>
                            </div>
                            <v-validator :errors="errors" parameter="CurrencyRate" :watch="model.CurrencyRate">
                                <div class="table-responsive mb-1" v-if="currencyRateObj != null &&!pleaseWait && currencyRateObj.CurrencyType && model.CurrencyType != null">
                                    <table class="table table-sm table-bordered mb-0" width="100%">
                                        <tbody>
                                            <tr>
                                                <th>Döviz Alış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.DovizAlis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.DovizAlisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Satış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.DovizSatis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.DovizSatisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Ef. Alış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.EffAlis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.EffAlisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Ef. Satış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.EffSatis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.EffSatisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">C/H Efektif Tarihi</label>
                            <v-validator :errors="errors" parameter="EffectiveDate" :watch="model.EffectiveDate">
                                <v-date-picker v-model="model.EffectiveDate" placeholder="C/H Efektif Tarihi"/>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Taşıyıcı</label>
                            <v-validator :errors="errors" parameter="EmployeeId" :watch="employee">
                                <v-select-list v-model="employee" :options="employees" label="Combine" v-on:search="searchEmployees" placeholder="Taşıyıcı" :loading="employeeLoading"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-md-12 text-right">
                            <v-executer :loading="saveLoading" :action="save"> Kaydet </v-executer>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="col-lg-8">
                <b-card no-body class="">
                    <v-table    ref="table"
                            name="vault-actions"
                            with-items
                            :settings="false"
                            :fields="fields"
                            search
                            :buttons="buttons"
                            :items="kasaHareketToday">
                        <template #additional-actions>
                            <h4 class="mb-0">Bugünkü Hareketler</h4>
                        </template>
                        </v-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import { BCard,BFormInput,BFormRadio,BOverlay } from 'bootstrap-vue'
import NetsisOperationsApi from '@/api/netsis-operations'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import VExecuter from '@/components/VExecuter.vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import { printFis } from '../components/fis/print-fis'
import moment from 'moment'
import { printTediyeFis } from '../components/fis/print-tediye-fis'

export default {
    components:{
        BCard,
        BFormRadio,
        VCurrencyInput,
        BFormInput,
        VExecuter,
        BOverlay,
    },
    data(){
        return{
            errors:{},
            saveLoading:false,
            projectCodes:[
                {value:'R',label:'Banka 1'},
                {value:'G',label:'Banka 2'},
            ],
            model:{
                CurrencyAmount:0,
                Amount:0,
                EffectiveDate:moment().format('YYYY-MM-DD'),
                ProjectCode:null,
                VaultCode:null,
                VaultName:null,
                DestinationKasaKod:null,
                DestinationKasaAdi:null,
                CurrencyType:null,
                IsCurrency:null,
                CurrencyRate:null,
                EmployeeId:null
            },
            pleaseWait: false,
            kasaLoading:false,
            kasaAllLoading:false,
            kasaList:[],
            kasaListAll:[],
            currencyRateObj:{
                CurrencyType:null,
                Date:null,
                DovizAlis:null,
                DovizSatis:null,
                EffAlis:null,
                EffSatis:null,
                DovizAliStr:null,
                DovizSatisStr:null,
                EffAlisStr:null,
                EffSatisStr:null,
            },
            calculatedValue:0,
            employeeLoading:false,
            employees:[],
            fields:[
                { name:'Kasa Kodu',key:'KSMAS_KOD', tdClass:'text-nowrap',thClass:'w-6'},
                { name:'Kasa Adı',key:'KSMAS_NAME',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tarih',key:'TARIHStr',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Zaman',key:'ZAMAN',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'G/Ç',key:'IO',thClass:'w-7', tdClass:'text-nowrap'},
                { name:'Fiş No',key:'FIS_NO',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tip',key:'TIP',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Açıklama',key:'ACIKLAMA',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'TMS Açıklama',key:'TMSVaultDescription',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tutar',key:'TUTARStr', tdClass:'text-nowrap text-right',thClass:'w-7', tdClass:'text-nowrap text-right'},
                { name:'Cari/Muh',key:'CARI_MUH', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Kod',key:'KOD',thClass:'w-7', tdClass:'text-nowrap', tdClass:'text-nowrap'},
                { name:'Cari Adı',key:'CARI_ISIM',thClass:'w-7', tdClass:'text-nowrap '},
                { name:'Muh. Adı', key:'MUH_ADI', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Plasiyer Adı',key:'PLASIYER_ISIM',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Şube Adı',key:'SUBE_ADI', tdClass:'text-nowrap',thClass:'w-16'},
            ],
            buttons:[
                { text:"Fiş Yazdır",key:"fis",icon:"PrinterIcon",variant:"primary",action:this.print, },
                { text:"Yevmiye Fişi Yazdır",key:"ted-fis",icon:"PrinterIcon",variant:"secondary",action:this.printTediye },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.deleteHareket },
            ],
            kasaHareketToday:[]
        }
    },
    mounted(){
        this.getKasaList()
        this.getKasaListAll()
        this.getKasaHareketToday()
    },
    methods:{
        getKasaHareketToday(){
            this.$refs.table.setLoading(true)
            NetsisOperationsApi.GetTransferKasaHareketToday().then((res)=>{
                this.kasaHareketToday = res.data.Data
                this.$refs.table.setLoading(false)
            }).catch(err=> {
                this.$refs.table.setLoading(false)
                console.log(err)
            })
        },
        clearForm(){
            this.model.CurrencyAmount = 0
            this.model.Amount = 0
            this.model.EffectiveDate = moment().format('YYYY-MM-DD')
            this.model.ProjectCode = null
            this.model.DestinationKasaKod = null
            this.model.DestinationKasaAdi = null
            this.model.CurrencyType = null
            this.model.IsCurrency = null
            this.model.CurrencyRate = null
            this.model.EmployeeId = null
        },
        save(){
            this.saveLoading=true
            NetsisOperationsApi.TransferKasaToCari(this.model).then((res)=>{
                this.$result(res)
                this.saveLoading=false
                if(res.data.Success){
                    this.clearForm()
                    this.getKasaHareketToday()
                }
            }).catch(err=> {
                this.saveLoading=false
                this.$result(null,err)
            })
        },
        calculateValue(){
            this.calculatedValue= this.currencyRateObj.Rate * this.model.Amount
        },
        getKasaDovizDeger(){
            this.getKasaHareketToday()
            this.pleaseWait=true
            this.model.CurrencyType = this.model.CurrencyType == null ? 0 : this.model.CurrencyType
            NetsisOperationsApi.GetNetsisCurrencyData(this.model.CurrencyType).then((res) => {
                if(res.data.Data != null){
                    this.currencyRateObj = res.data.Data
                }else{
                    this.currencyRateObj = null
                }
                this.pleaseWait=false
            }).catch(err=> {
                console.log(err)
            })
        },
        getKasaList(){
            this.kasaLoading = true
            NetsisOperationsApi.GetKasaList().then(res => {
                    this.kasaList = res.data.Data
                    this.kasaLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaLoading = false
            })
        },
        getKasaListAll(){
            this.kasaAllLoading = true
            NetsisOperationsApi.GetKasaListAll().then(res => {
                    this.kasaListAll = res.data.Data
                    this.kasaAllLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaAllLoading = false
            })
        },
        searchEmployees(search){
            if(search){
                this.employeeLoading = true
                EmployeeOperationsApi.Employee.Search(search)
                .then(res=>{
                    this.employees = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.IdentityNumber,d.FullName].join(' - ')
                    }))
                    this.employeeLoading = false
                }).catch(err=>{ 
                    this.employeeLoading = false 
                })
            }
        },
        print(i){
            if(i.FIS_NO){
                this.$refs.table.rowLoading(true)
                NetsisOperationsApi.Fis(i.FIS_NO).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        printFis(res.data.Data)
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs.table.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
        printTediye(i){
            if(i.FIS_NO && i.TIP && i.SIRA){
                this.$refs.table.rowLoading(true)
                NetsisOperationsApi.TediyeFis(i.FIS_NO,i.TIP,i.SIRA).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        printTediyeFis(res.data.Data)
                    } else {
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs.table.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
        deleteHareket(i){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${i.SIRA} sıra numaralı işlemi silecektir ve geri alınamaz.`)
            .then(c => {
                if(c){
                    NetsisOperationsApi.DeleteKasaHareket(i.SIRA).then(res => {
                        this.$result(res)
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                    })
                }
            }).catch(err => {
                this.$result(null,err)
            })
        }
    },
    computed:{
        kasa:{
            get:function(){
                return this.kasaList.find(s=>s.KSMAS_KOD==this.model.VaultCode)
            },
            set:function(value){
                this.model.VaultCode = value?.KSMAS_KOD || null
                this.model.VaultName = value?.KSMAS_NAME || null
                this.model.CurrencyType = value?.DOVIZTIPI || null
                this.model.IsCurrency = value?.DOVIZLI || null
            }
        },
        dkasa:{
            get:function(){
                return this.kasaListAll.find(s=>s.KSMAS_KOD==this.model.DestinationKasaKod)
            },
            set:function(value){
                this.model.DestinationKasaKod = value?.KSMAS_KOD || null
                this.model.DestinationKasaAdi = value?.KSMAS_NAME || null
            }
        },
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.model.EmployeeId)
            },
            set:function(value){
                this.model.EmployeeId = value?.Id || null
            }
        },
        projectCode:{
            get:function(){
                return this.projectCodes.find(s=>s.value==this.model.ProjectCode)
            },
            set:function(value){
                this.model.ProjectCode = value?.value || null
            }
        }
    }
}
</script>